export default {  
  listItem: [
    {
      title: "ENE",
      imgLogo: require("@/assets/LogoENE.png"),
      backgroundImage: require("@/assets/img/sidebar.jpg"),
      link: "/exercises",
      pages: [
        { name: "Accueil", to: "/exercises" },
        { name: "Exercice", to: "/exercise" }
      ]
    },

    {
      title: "GCE",
      imgLogo: require("@/assets/0_GCE icone.png"),
      backgroundImage: require("@/assets/img/BackgroundGCE.png"),
      link: "/cycles",
      pages: [
        { name: "Accueil", to: "/cycles" },
        { name: "Cycle", to: "/cycle" }
      ]
    },

    // { title: "GPE", imgLogo: require("@/assets/0_GPE icone.png") }
  ]
};